import { Project } from 'core/models/project';
import React, { useState } from 'react';
import { createDropdownList } from 'components/views/atoms/DropdownList';
import styled from '@emotion/styled';
import { ignore } from 'utility/ignore';
import { fontFamily } from 'components/views/default';

const Item = styled.div({
    fontSize: '14px',
    fontFamily,
    padding: '10px',
});

const ProjectDropdownList = createDropdownList<Project>(project => <Item>{project.name}</Item>);

const Title = styled.div({
    color: 'white',
    fontSize: '14px',
    fontFamily,
    padding: '10px',
    userSelect: 'none',
    ':hover': {
        color: '#23527c',
    },
});

const ProjectName = styled.span({
    fontSize: '20px',
    marginLeft: '0.3em',
});

export type ProjectSelectorProps = {
    projects: Project[];
    selected: Project | null;
    onSelect: (project: Project) => void;
};

export const ProjectSelector = (props: ProjectSelectorProps) => {
    const [listVisible, setListVisible] = useState<boolean>(false);
    ignore(listVisible);
    ignore(setListVisible);

    function onSelect(project: Project) {
        if (project.id === '') return;
        props.onSelect(project);
    }

    const values = props.projects.length > 0
        ? props.projects
        : [{ name: '(no project)', id: '' }]
        ;

    return (
        <React.Fragment>
            <ProjectDropdownList values={values} direction={'DOWN'} onSelect={onSelect}>
                {
                    props.selected
                        ? <Title>
                            <span>PROJECT:</span>
                            <ProjectName>{props.selected.name}</ProjectName>
                        </Title>
                        :
                        props.projects.length > 0
                            ? <Title>
                                <ProjectName>please select project</ProjectName>
                            </Title>
                            : <Title>
                                <ProjectName>no project</ProjectName>
                            </Title>
                }
            </ProjectDropdownList>
        </React.Fragment>
    );
};
